$(function () {
    // *** Common ***
    function replacePlaceholder(url, placeholder, value) {
        url = url.replace(placeholder, value);
        url = url.replace(encodeURI(placeholder), value);
        return url;
    }

    // *** Header ***
    $(".nav-element .heading-summary").click(function () {
        let navElement = $(this).closest(".nav-element");
        $(navElement).toggleClass("view-mode-open");
    });

    $(".nav-element .heading-summary a.clear-link").click(function (event) {
        if (typeof window !== 'undefined') { window.location = event.currentTarget.href; }
        return false;
    });

    // *** Ad Type ***
    $(".adtype-element .adtype-actions button.go").click(function () {
        let form = $(this).closest('.adtype-element').find('.adtype-selection form');
        form.submit();
    });

    // *** Aspect ***
    $(".aspect-navigation-element .view-link").click(function () {
        $(this).hide();
        $(this).siblings(".view-link").show();
        $(this).siblings(".default-facets").children("li.facet-hidden").toggleClass("show");
    });

    $(".aspect-navigation-element .add-another-link").click(function () {
        $(this).hide();
        $(this).siblings(".add-another-link").hide();
        $(this).siblings(".add-another-content").show();
    });

    // *** Keyword ***
    $(".keyword-element .keyword-selection button.go").click(function () {
        let keywordEle = $(this).siblings("input");
        let keywordValue = $(keywordEle).val();
        if (keywordValue === "") {
            alert("Please enter keyword.");
            return;
        }

        let placeholder = $(this).data("placeholder");
        let expressionUrl = $(this).data("expression-url");
        let url = replacePlaceholder(expressionUrl, placeholder, keywordValue);
        if (typeof window !== 'undefined') { window.location = url; }
    });

    $(".keyword-element .keyword-selection input").keypress(function (e) {
        if (e.which === 13) {
            $(this).siblings("button.go").click();
        }
    });

    // *** Range ***
    $(".range-element .range-actions button.go").click(function () {
        let lowerPlaceholder = $(this).data("lower-placeholder");
        let upperPlaceholder = $(this).data("upper-placeholder");
        let expressionUrl = $(this).data("expression-url");

        let rangeElement = $(this).closest(".range-element");
        let lowerValue = $(rangeElement).find(".range-min input").val();
        let upperValue = $(rangeElement).find(".range-max input").val();

        if (lowerValue !== "" && upperValue !== "") {
            if (parseInt(lowerValue) > parseInt(upperValue)) {
                let tempLowerValue = lowerValue;
                lowerValue = upperValue;
                upperValue = tempLowerValue;
            }
        }

        let url = expressionUrl;
        url = replacePlaceholder(url, lowerPlaceholder, lowerValue);
        url = replacePlaceholder(url, upperPlaceholder, upperValue);
        if (typeof window !== 'undefined') { window.location = url; }
    });

    $("#retail-nav-component .autocomplete-dropdown i").click(function () {
        const elm = $(this)
            .closest("#retail-nav-component .autocomplete-dropdown")
            .find("ul");
        const isHidden = elm.is(":hidden");

        $("#retail-nav-component .autocomplete-dropdown ul").hide();

        isHidden ? $(elm).show() : $(elm).hide();
    });

    $("#retail-nav-component .autocomplete-dropdown").click(function (e) {
        e.stopPropagation();
    });

    $(document).click(function () {
        $("#retail-nav-component .autocomplete-dropdown ul").hide();
    });

    $("#retail-nav-component .autocomplete-dropdown li").click(function () {
        const value = $(this).data("value");
        $(this).closest("#retail-nav-component .autocomplete-dropdown").find("input").val(value);
        $(this).closest("ul").toggle();
    });

    // *** poi / postcode ***
    $(".poi-element .poi-actions button.go").click(function () {
        let locationPlaceholder = $(this).data("location-placeholder");
        let distanceKmPlaceholder = $(this).data("distinkms-placeholder");
        let expressionUrl = $(this).data("expression-url");

        let poiElement = $(this).closest(".poi-element");
        let postcode = $(poiElement).find(".poi-selection input").val();
        let distanceInKm = $(poiElement).find(".poi-selection select").val();

        if (isNaN(postcode) || postcode.length !== 4) {
            alert('Please enter valid postcode.');
            $(poiElement).find(".poi-selection input").focus();
            return false;
        }

        let url = expressionUrl;
        url = replacePlaceholder(url, locationPlaceholder, postcode);
        url = replacePlaceholder(url, distanceKmPlaceholder, distanceInKm);
        if (typeof window !== 'undefined') { window.location = url; }
    });

});